/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import { getBraindateId } from '@braindate/domain/lib/braindate/util';

import CheckInTakeOverDumb from './CheckInTakeOverDumb';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import { getBraindate } from 'src/shared/domain/braindate/selector/braindateSelectors';

type Props = {
  notification: Notification<>,
};

const mapStateToProps = (state: Object, { notification }: Props): Object => {
  // $FlowIssue
  const braindateId: string = getBraindateId(getNotificationData(notification));
  const braindate = getBraindate(state, { id: braindateId });
  return {
    event: getEventSafely(state),
    notification,
    braindate,
    selfUser: getSelf(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  ownProps: Props,
): Object => {
  const { notification } = ownProps;
  // $FlowIssue

  return {
    ...stateProps,

    handleDismiss() {
      dispatch(dismissNotification(notification));
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInTakeOverDumb);
